import { Component, ReactNode } from "react";
import { Loader } from "./App";

interface ErrorBoundaryProps {
    children: ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: any) {
        if (error?.message?.includes("Loading chunk")) {
            window.location.reload();
        }
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return <Loader />;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
